import {Accept, doApiRequest, Method, Module} from '..';

export enum ResourceDms {
  Dms = '/Dms',
}

export async function getData(
    token: string,
): Promise<Blob> {
  return doApiRequest({
    accept: Accept.OctetStream,
    method: Method.Get,
    module: Module.Dms,
    resource: ResourceDms.Dms,
    id: token,
  });
}
